import { format } from 'date-fns';

export function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatDateTable(timestampStr, dateOnly) {
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const date = new Date(timestampStr);
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  return dateOnly ? `${day} ${month} ${year}` : `${day} ${month} ${year} at ${hours}:${minutes}:${seconds}`;
}

export function formattedRange(date) {
  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) {
    // Invalid date
   return
  }
  return format(parsedDate, 'yyyy-MM-dd');
}

export function convertDateToIso(timestampStr) {
  return new Date(timestampStr * 1000);
}

export function formatDateTableMY(monthp, year) {
  const months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const month = months[monthp];
  return `${month} ${year}`;
}

export function getCookie(name) {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

export function filterArrayByString(arr, searchString) {
  const lowerSearchString = searchString.toLowerCase();

  return arr.filter(obj => {
    return Object.values(obj).some(value =>
      value !== null && value !== undefined && value.toString().toLowerCase().includes(lowerSearchString)
    );
  });
}

export const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  return {
    frontTime: formatDate(date),
    timestamp: formatDateTable(timestamp),
    compareTime: date
  };
};

export function formatCurrency(value, currency) {
  if (currency) {
    if (currency === "SATS") {
      return Number(value) + ' sats'
    }
    return Number(value).toLocaleString('de-DE', {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  return Number(value).toLocaleString('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

export function trimString(str) {
  return str.length > 30 ? str.slice(0, 30) + "..." : str;
}
